import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import { Link } from 'react-router';
import classNames from 'classnames';
import formRules from './formRules';
import ErrorComponent from '../../components/Error';
import {
  injectFormState,
  onChangeFieldText,
  onBlurFieldText,
  formValidate,
} from '../../utils/form';
// translate
import messages from './messages';

class Login extends Component {
  constructor(props) {
    super(props);

    const attributes = {
      login: '',
      password: '',
    };

    this.state = Object.assign(
      {
        attributes,
        isRememberMe: true,
      },
      injectFormState(formRules, attributes),
    );

    this.formValidate = formValidate.bind(this);
    this.onChangeFieldText = onChangeFieldText.bind(this);
    this.onBlurFieldText = onBlurFieldText.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onRememberMe = this.onRememberMe.bind(this);
  }

  onRememberMe() {
    this.setState({
      isRememberMe: !this.state.isRememberMe,
    });
  }

  onSubmit() {
    this.formValidate(this.state.attributes).then((data) => {
      if (data.status) {
        const { isRememberMe } = this.state;
        this.props.onLoginClick(
          Object.assign(this.state.attributes, { isRememberMe }),
        );
      }
    });
  }

  renderForm() {
    const { intl, isFetching } = this.props;
    const { validation } = this.state.formSchema;

    return (
      <form className="popup-form" method="post">
        <label className="label" htmlFor="login">
          {validation.login.message &&
            <span className="popup-form-error">
              {intl.formatMessage(validation.login.message)}
            </span>}
          <input
            type="text"
            name="login"
            placeholder={intl.formatMessage(messages.placeholderLogin)}
            onChange={this.onChangeFieldText}
            onBlur={this.onBlurFieldText}
          />
        </label>

        <label className="label" htmlFor="password">
          {validation.password.message &&
            <span className="popup-form-error">
              {intl.formatMessage(validation.password.message)}
            </span>}
          <input
            type="password"
            name="password"
            placeholder={intl.formatMessage(messages.placeholderPassword)}
            onChange={this.onChangeFieldText}
            onBlur={this.onBlurFieldText}
          />
        </label>

        <div className="label">
          <Link className="forgot-password" to="#forgot-password">
            {intl.formatMessage(messages.forgotPassword)}
          </Link>

          <a
            role="button"
            className="link-wrapper"
            tabIndex="0"
            onClick={this.onRememberMe}
          >
            <label className="checkbox-wrap" htmlFor="remember">
              <span
                className={classNames('checkbox', {
                  checked: this.state.isRememberMe,
                })}
              >
                <input
                  type="checkbox"
                  name="isRememberMe"
                  value="1"
                  onChange={this.onRememberMe}
                  checked={this.state.isRememberMe}
                />
              </span>

              <span>{intl.formatMessage(messages.rememberMe)}</span>
            </label>
          </a>
        </div>

        <button
          className="trans"
          type="button"
          disabled={isFetching}
          onClick={this.onSubmit}
        >
          {intl.formatMessage(messages.loginButton)}
        </button>
      </form>
    );
  }

  render() {
    const { intl, loginErrorMessage, isFetching } = this.props;

    return (
      <div>
        {this.renderForm()}
        {loginErrorMessage &&
          !isFetching &&
          <ErrorComponent>{loginErrorMessage}</ErrorComponent>}
        <Link className="button trans go-register" to="#signup">
          {intl.formatMessage(messages.signupButton)}
        </Link>
      </div>
    );
  }
}

Login.propTypes = {
  intl: intlShape.isRequired,
  onLoginClick: PropTypes.func.isRequired,
  isFetching: PropTypes.bool.isRequired,
  loginErrorMessage: PropTypes.any,
};

Login.defaultProps = {
  loginErrorMessage: false,
};

export default injectIntl(Login);



// WEBPACK FOOTER //
// ./src/components/Login/index.js